import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const HittaAnlaggningsId = lazy(() => import("@/pages/verktyg/HittaAnlaggningsId"));

export const Route = createFileRoute("/verktyg/hitta-anlaggnings-id")({
  head: () => seoHead("/verktyg/hitta-anlaggnings-id", { description: "Anläggnings-ID är en unik kod för just din mätarpunkt. Vissa elbolag behöver det när du tecknar avtal – så här hittar du det." }),
  component: () => <HittaAnlaggningsId />,
});
